import { render, staticRenderFns } from "./ContentCampaignItemsCountByStatus.vue?vue&type=template&id=38f0f881&"
import script from "./ContentCampaignItemsCountByStatus.vue?vue&type=script&lang=ts&"
export * from "./ContentCampaignItemsCountByStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QTooltip,QSeparator});
